import { Controller } from "@hotwired/stimulus"
import { convertReferenceChips } from "../lib/reference_chips"

// Wraps reference links inside this element into the shared pill chips. Use on
// any timeline/markdown region (e.g. the task history timeline) that renders
// reference links but isn't driven by the activity-stream controller.
export default class extends Controller {
  connect() {
    convertReferenceChips(this.element)
  }
}
